<template>
  <section class="content-register-bonus">
    <Breadcrumb :links="links"/>
    <form class="content-register-bonus-form">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedContent && selectedContent !== ''}">
            <select v-model="selectedContent">
              <option value="" selected disabled>Selecione o conteúdo</option>
              <option value="phrase-diary">Frase do dia</option>
              <option value="text">Texto</option>
              <option value="challenges">Desafios</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <template v-if="selectedContent && selectedContent !== ''">
          <div class="col-12 col-lg-6">
            <div class="content-input-default">
              <input type="text" name="title" value="" placeholder="Título" required/>
            </div>
          </div>
          <div class="col-12">
            <div class="content-input-default">
              <textarea placeholder="Descrição"></textarea>
            </div>
          </div>
          <div class="col-12" v-if="selectedContent === 'challenges'">
            <div class="content-bonus">
              <div class="content-bonus-header">
                <h2>Desafios</h2>
                <button class="btn--register" @click="$bvModal.show('modal-challenge')">
                  <img class="img-fluid" src="@/assets/img/icon-add-challenges.png" alt="icon add" title="icon add"/>
                </button>
              </div>
              <div class="content-bonus-body">
                <div class="row">
                  <div class="col-12 col-md-6" v-for="n in 4" :key="n">
                    <CardChallenges/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <button class="btn-green">Salvar</button>
          </div>
        </template>
      </div>
    </form>
    <ModalChallenge/>
    <ModalDelete/>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardChallenges from '../Challenges/components/CardChallenges';
import ModalChallenge from '../Challenges/components/modals/ModalChallenge';
import ModalDelete from '../Challenges/components/modals/ModalDelete';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tarefas',
          routerName: 'Tasks'
        },
        {
          name: 'A Procastinação',
          routerName: 'RegisterPlans'
        },
        {
          name: 'Cadastrar Conteúdo',
          routerName: 'RegisterContents'
        },
        {
          name: 'Bônus',
          routerName: 'Bonus'
        },
      ],
      selectedContent: '',
    }
  },
  components: {
    Breadcrumb,
    CardChallenges,
    ModalChallenge,
    ModalDelete
  }
}
</script>

<style lang="scss" scoped>
.content-register-bonus {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.content-bonus {
  margin-top: 20px;
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    margin-bottom: 30px;
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--red-light);
      margin-bottom: 0;
    }
    .btn--register {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: 0;
      border: 1px solid transparent;
      box-shadow: 0px 1px 3px rgb(0,0,0,0.25);
      border-radius: 10px;
      transition: 500ms;
      &:hover {
        cursor: pointer;
        border-color: var(--yellow);
      }
    }
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
